module.exports = __webpack_public_path__ + "static/img/culture_icon_10.c1ced424.svg";